export default __webpack_public_path__ + "static/media/home-aritsan-banner-comp.c86bef68.jpg";